import PropTypes from 'prop-types';

import ImageDisplay from '../imageDisplay';

const TwoColumnFeatured = ({ featuredIcons, image, title, richTextSubtitle }) => {
	const icons = featuredIcons.map((item) => ({
		icon: {
			data: item?.icon?.gatsbyImageData,
			src: item?.icon?.file?.url,
			alt: item?.icon?.description,
		},
		title: item?.title,
		body: item?.description?.childMarkdownRemark?.html,
	}));
	return (
		<div className="section tc-featured">
			<div>
				<h2 className="typography typography--h2 typography--secondary tc-featured__title-desktop">
					{title}
				</h2>
				{richTextSubtitle && (
					<p className="typography typography--subtle-big typography--secondary tc-featured__subtitle-desktop">
						{richTextSubtitle.subtitle}
					</p>
				)}
				<div className="section__content tc-featured__content">
					<div className="tc-featured__image-wrapper">
						<ImageDisplay
							className="tc-featured__image"
							alt={image?.description}
							image={image?.gatsbyImageData}
							src={image?.file?.url}
						/>
					</div>
					<div className="tc-featured__body">
						<h2 className="typography typography--h2 typography--secondary tc-featured__title-mobile">
							{title}
						</h2>
						{richTextSubtitle && (
							<p className="typography typography--subtle-big typography--secondary tc-featured__subtitle-mobile">
								{richTextSubtitle.subtitle}
							</p>
						)}
						<div className="tc-featured__items">
							{icons.map(({ title, icon, body }) => (
								<div className="tc-featured__items-item" key={title}>
									<figure className="tc-featured__items-item-icon">
										<ImageDisplay
											alt={icon.alt}
											image={icon.data}
											src={icon.src}
										/>
									</figure>
									<div className="tc-featured__items-item-body">
										<h3 className="typography typography--h5 typography--secondary">
											{title}
										</h3>
										<div
											className="typography typography--body typography--tertiary"
											dangerouslySetInnerHTML={{
												__html: body,
											}}
										/>
									</div>
								</div>
							))}
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

const PropTypeImage = PropTypes.shape({
	gatsbyImageData: PropTypes.object,
	file: PropTypes.shape({ url: PropTypes.string }),
	description: PropTypes.string,
});

TwoColumnFeatured.propTypes = {
	featuredIcons: PropTypes.arrayOf(
		PropTypes.shape({
			icon: PropTypes.object,
			title: PropTypes.string,
			description: PropTypes.object,
		})
	).isRequired,
	image: PropTypeImage.isRequired,
	title: PropTypes.string.isRequired,
	richTextSubtitle: PropTypes.shape({ subtitle: PropTypes.string }),
};

export default TwoColumnFeatured;
